import React, { useMemo, useRef, useState,useEffect } from "react";
import withRouter from "../../../components/Common/withRouter";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
  Label,
  Input,
  CardTitle,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

const ShippingCharge = () => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentshippingCharge, setCurrentshippingCharge] = useState(null);
  const [shippingChargeData, setshippingChargeData] = useState([]);
  const [error, setError] = useState(null);
  const toggleModal = () => setModal(!modal);

  
  
  const fetchshippingChargeData = async () => {
        try {
          setError(null); // Reset error before fetching
          const response = await fetch(`${baseurl}/admin/master/shippingcharge`);
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();
          setshippingChargeData(data);
        } catch (error) {
          setError(error.message);
        }
      };
      
      useEffect(() => {
        fetchshippingChargeData();
      }, []);
  

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (currentshippingCharge && currentshippingCharge.id) || "",
      stateName: (currentshippingCharge && currentshippingCharge.state_name) || "",
      stateCode: (currentshippingCharge && currentshippingCharge.state_code) || "",
      kgCharge: (currentshippingCharge && currentshippingCharge.kg_charge) || "",
      cgst: (currentshippingCharge && currentshippingCharge.cgst) || "",
      sgst: (currentshippingCharge && currentshippingCharge.sgst) || "",
      igst: (currentshippingCharge && currentshippingCharge.igst) || "",
    },
    validationSchema: Yup.object({
      stateName: Yup.string().required("Please enter the state name"),
      stateCode: Yup.string().required("Please enter the state code"),
      kgCharge: Yup.string().required("Please enter the kg charge"),
      cgst: Yup.string().required("Please enter the cgst"),
      sgst: Yup.string().required("Please enter the sgst"),
      igst: Yup.string().required("Please enter the igst"),
    }),
    onSubmit: async (values) => {
      console.log("submitted");
      const { id, stateName,stateCode, kgCharge, cgst,sgst,igst } = values;
        
            try {
              let response;
              if (isEdit) {
                // For edit, make an API PUT request
                response = await fetch(baseurl+`/admin/master/shippingcharge/${id}`, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    stateName: stateName,
                    stateCode: stateCode,
                    kgCharge : kgCharge,
                    cgst:cgst,
                    sgst:sgst,
                    igst:igst,
                  }),
                });
                if (!response.ok) {
                  throw new Error("Error updating shipping charge");
                }
                toast.success('shipping charge updated successfully!', 'success');
                fetchshippingChargeData();
                formik.resetForm();
              } else {
                
                response = await fetch(baseurl+'/admin/master/shippingcharge', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    stateName: stateName,
                    stateCode: stateCode,
                    kgCharge : kgCharge,
                    cgst:cgst,
                    sgst:sgst,
                    igst:igst,
                  }),
                });
                console.log(response.status);
                if (!response.ok) {
                  throw new Error("Error adding new shipping charge");
                }
                toast.success('New shipping charge added successfully!', 'success');
                fetchshippingChargeData();
              }
              // Close modal or do further actions
              toggleModal();
              formik.resetForm();
            } catch (error) {
              console.error(error);
              // Handle any errors, show an error message if needed
            }
      
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "State Name",
        accessor: "state_name",
        filterable: true,
      },
      {
        Header: "State Code",
        accessor: "state_code",
        filterable: true,
      },
      {
        Header: "KG Charge",
        accessor: "kg_charge",
        filterable: true,
      },
      {
        Header: "cgst",
        accessor: "cgst",
        filterable: true,
      },
      {
        Header: "sgst",
        accessor: "sgst",
        filterable: true,
      },
      {
        Header: "igst",
        accessor: "igst",
        filterable: true,
      },
      
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-success"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

 const handleEditClick = (category) => {
    setCurrentshippingCharge(category);
    setIsEdit(true);
    toggleModal();
  };

  

  const handleAddShippingCharge = () => {
    setCurrentshippingCharge(null);
    setIsEdit(false);
    toggleModal();
  };

  document.title = "Shipping Charges | Vekart";

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Shipping Charges" breadcrumbItem="Manage Shipping Charges" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={shippingChargeData}
                    isGlobalFilter={true}
                    customPageSize={10}
                    isAddCategory={false}
                    handleAddShippingCharge={handleAddShippingCharge}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Modal for Add/Edit Categories */}
          <Modal
            isOpen={modal}
            toggle={toggleModal}
            backdrop="static"
            keyboard={false}
            size="lg"
            scrollable={true}
          >
            <ModalHeader toggle={toggleModal} tag="h4">
              {isEdit ? "Edit Shipping Charge" : "Add Shipping Charge"}
            </ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">State Name</Label>
                      <Input
                        name="stateName"
                        type="text"
                        placeholder="Insert State Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        readOnly
                        value={formik.values.stateName || ""}
                        invalid={
                          formik.touched.stateName &&
                          formik.errors.stateName
                            ? true
                            : false
                        }
                      />
                      {formik.touched.stateName &&
                      formik.errors.stateName ? (
                        <FormFeedback type="invalid">
                          {formik.errors.stateName}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">State Code</Label>
                      <Input
                        name="stateCode"
                        type="text"
                        placeholder="Insert State Code"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.stateCode || ""}
                        invalid={
                          formik.touched.stateCode &&
                          formik.errors.stateCode
                            ? true
                            : false
                        }
                      />
                      {formik.touched.stateCode &&
                      formik.errors.stateCode ? (
                        <FormFeedback type="invalid">
                          {formik.errors.stateCode}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">kg Charge</Label>
                      <Input
                        name="kgCharge"
                        type="number"
                        step="0.01"
                        placeholder="Insert kg Charge"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.kgCharge || ""}
                        invalid={
                          formik.touched.kgCharge &&
                          formik.errors.kgCharge
                            ? true
                            : false
                        }
                      />
                      {formik.touched.kgCharge &&
                      formik.errors.kgCharge ? (
                        <FormFeedback type="invalid">
                          {formik.errors.kgCharge}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">SGST</Label>
                      <Input
                        name="sgst"
                        type="number"
                        step="0.01"
                        placeholder="Insert sgst"
                        
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.sgst || ""}
                        invalid={
                          formik.touched.sgst &&
                          formik.errors.sgst
                            ? true
                            : false
                        }
                      />
                      {formik.touched.sgst &&
                      formik.errors.sgst ? (
                        <FormFeedback type="invalid">
                          {formik.errors.sgst}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">CGST</Label>
                      <Input
                        name="cgst"
                        type="number"
                        step="0.01"
                        placeholder="Insert cgst"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.cgst || ""}
                        invalid={
                          formik.touched.cgst &&
                          formik.errors.cgst
                            ? true
                            : false
                        }
                      />
                      {formik.touched.cgst &&
                      formik.errors.cgst ? (
                        <FormFeedback type="invalid">
                          {formik.errors.cgst}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="mb-3">
                      <Label className="form-label">IGST</Label>
                      <Input
                        name="igst"
                        type="number"
                        step="0.01"
                        placeholder="Insert Igst"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.igst || ""}
                        invalid={
                          formik.touched.igst &&
                          formik.errors.igst
                            ? true
                            : false
                        }
                      />
                      {formik.touched.igst &&
                      formik.errors.igst ? (
                        <FormFeedback type="invalid">
                          {formik.errors.igst}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  
                  
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button type="submit" color="success">
                        {isEdit ? "Update" : "Save"}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>

         
        </Container>
      </div>
    </>
  );
};

export default withRouter(ShippingCharge);
